"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _shallowEqual = _interopRequireDefault(require("react-utils/shallowEqual"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Functions = require("../core/Functions");

var _BrowserTest = require("../utils/BrowserTest");

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _Timers = require("../utils/Timers");

var _UIOverhang = _interopRequireDefault(require("./UIOverhang"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n\n  /*\n    Temporary patch for Chrome 72 flexbug:\n    https://bugs.chromium.org/p/chromium/issues/detail?id=927066\n\n    This rule only matters when the wrapper is modified to be display: flex,\n    as in UIScrollingColumn.\n  */\n  min-height: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var sides = ['top', 'bottom', 'left', 'right'];

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "UIScrollOverhang__Wrapper",
  componentId: "sc-1i3am91-0"
})(_templateObject());

var UIScrollOverhang =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIScrollOverhang, _PureComponent);

  function UIScrollOverhang() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIScrollOverhang);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIScrollOverhang)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.delayedMeasureScrollableArea = function () {
      (0, _Timers.cancelSchedulerCallback)(_this._timeout); // Ensure only one callback is queued at a time

      _this._timeout = (0, _Timers.requestSchedulerCallback)(_this.measureScrollableArea);
    };

    _this.measureScrollableArea = function () {
      var thisEl = _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)(_this)); // Bail out if our only children are the 4 scroll overhang elements


      if (thisEl == null || thisEl.children.length === 4) return;
      var childEl = thisEl.children[0];
      var computedStyles = getComputedStyle(childEl, null); // Patch for Firefox < 62: https://bugzilla.mozilla.org/show_bug.cgi?id=1467722

      if (computedStyles == null) return;
      var clientHeight = childEl.clientHeight,
          clientWidth = childEl.clientWidth,
          scrollHeight = childEl.scrollHeight,
          scrollLeft = childEl.scrollLeft,
          scrollTop = childEl.scrollTop,
          scrollWidth = childEl.scrollWidth;

      var isScrollable = function isScrollable(overflow) {
        return overflow === 'auto' || overflow === 'scroll';
      };

      var scrollsVertically = isScrollable(computedStyles.overflowY);
      var scrollsHorizontally = isScrollable(computedStyles.overflowX);
      var measuredScrollableArea = {
        top: scrollsVertically ? scrollTop : 0,
        bottom: scrollsVertically ? scrollHeight - clientHeight - scrollTop : 0,
        left: scrollsHorizontally ? scrollLeft : 0,
        right: scrollsHorizontally ? scrollWidth - clientWidth - scrollLeft : 0
      };

      if (!(0, _shallowEqual.default)(measuredScrollableArea, _this.state.measuredScrollableArea)) {
        _this.setState({
          measuredScrollableArea: measuredScrollableArea
        });
      }
    };

    _this.handleScroll = function (evt) {
      (0, _Functions.callIfPossible)(_this.props.onScroll, evt);

      _this.delayedMeasureScrollableArea();
    };

    _this.state = {
      measuredScrollableArea: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      }
    };
    return _this;
  }

  (0, _createClass2.default)(UIScrollOverhang, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // IE needs a longer delay before measurement, or else it sometimes returns an absurdly large
      // scrollWidth.
      if ((0, _BrowserTest.isIE11)()) {
        this._frame = requestAnimationFrame(function () {
          _this2._frame = requestAnimationFrame(_this2.measureScrollableArea);
        });
      } else {
        this.delayedMeasureScrollableArea();
      }

      addEventListener('resize', this.delayedMeasureScrollableArea);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.measuredScrollableArea === this.state.measuredScrollableArea) {
        this.delayedMeasureScrollableArea();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeEventListener('resize', this.delayedMeasureScrollableArea);
      (0, _Timers.cancelSchedulerCallback)(this._timeout);
      cancelAnimationFrame(this._frame);
    }
  }, {
    key: "getClonedChild",
    value: function getClonedChild(children, measuredScrollableArea) {
      var child = _react.default.Children.only(children);

      var childTabIndex = child.props && child.props.tabIndex;
      var childIsScrollable = sides.some(function (side) {
        return measuredScrollableArea[side] > 0;
      });
      return _react.default.cloneElement(child, {
        tabIndex: childIsScrollable ? childTabIndex || 0 : childTabIndex
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          forceOverhangs = _this$props.forceOverhangs,
          gradientColor = _this$props.gradientColor,
          Overhang = _this$props.Overhang,
          size = _this$props.size,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "forceOverhangs", "gradientColor", "Overhang", "size"]);
      var measuredScrollableArea = this.state.measuredScrollableArea;
      var clonedChild = this.getClonedChild(children, measuredScrollableArea);
      var overhangProps = {
        gradientColor: gradientColor,
        size: size
      }; // Fade smoothly from 1 (scrollable area exceeds overhang size) to 0 (no scrollable area)

      var getOpacity = function getOpacity(side) {
        return forceOverhangs[side] ? 1 : Math.min((measuredScrollableArea[side] || 0) / size, 1);
      };

      return _react.default.createElement(Wrapper, (0, _extends2.default)({}, rest, {
        onScroll: this.handleScroll
      }), clonedChild, _react.default.createElement(Overhang, (0, _extends2.default)({}, overhangProps, {
        opacity: getOpacity('top'),
        side: "top"
      })), _react.default.createElement(Overhang, (0, _extends2.default)({}, overhangProps, {
        opacity: getOpacity('bottom'),
        side: "bottom"
      })), _react.default.createElement(Overhang, (0, _extends2.default)({}, overhangProps, {
        opacity: getOpacity('left'),
        side: "left"
      })), _react.default.createElement(Overhang, (0, _extends2.default)({}, overhangProps, {
        opacity: getOpacity('right'),
        side: "right"
      })));
    }
  }]);
  return UIScrollOverhang;
}(_react.PureComponent);

UIScrollOverhang.propTypes = {
  children: _propTypes.default.element.isRequired,
  forceOverhangs: _propTypes.default.shape({
    top: _propTypes.default.bool,
    bottom: _propTypes.default.bool,
    left: _propTypes.default.bool,
    right: _propTypes.default.bool
  }).isRequired,
  gradientColor: _UIOverhang.default.propTypes.gradientColor,
  onScroll: _propTypes.default.func,
  Overhang: RenderProp.getPropType(_UIOverhang.default),
  size: _UIOverhang.default.propTypes.size
};
UIScrollOverhang.defaultProps = {
  forceOverhangs: {
    top: false,
    bottom: false,
    left: false,
    right: false
  },
  gradientColor: _UIOverhang.default.defaultProps.gradientColor,
  Overhang: _UIOverhang.default,
  size: _UIOverhang.default.defaultProps.size
};
UIScrollOverhang.displayName = 'UIScrollOverhang';
var _default = UIScrollOverhang;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/scroll/UIScrollOverhang.js
// module id = 262
// module chunks = 0